<template>
  <footer class="text-muted" v-if="!$root.simple_layout">
            <div class="navbar-social pt-5 pb-4">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-3 col-md-6 left-content">
                            <div class="img-holder-paper-plane">
                                <img :src="getAssetImage('paper-plane.svg')">
                            </div>
                            <div class="subscribe-desc-holder">
                                <b class="text-dark fs-5">Sign up for Newsletter</b><br />
                                Enter your email to receive latest updates
                            </div>
                        </div>
                        <div class="col-xl-5 col-md-6 form-subs">
                            <div class="input-group mb-3">
                                  <MailchimpSignupForm
                                    :mailchimpUserId="mailchimpUserId"
                                    :mailchimpAudienceId="mailchimpAudienceId"
                                    :defaultMailchimpUserId="defaultMailchimpUserId"
                                    :defaultMailchimpAudienceId="defaultMailchimpAudienceId"
                                  />
                            </div>
                        </div>
                        <div class="col-xl-4 col-12 ">
                            <ul class="social-media list-inline text-xl-end text-start">
                                <li class="list-inline-item">
                                    <a href="https://www.facebook.com/ChangiRecommends" target="_blank">
                                    <img :src="getAssetImage('facebook-f.svg')">
                                    <span>Facebook</span>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a href="https://www.instagram.com/changirecommends/" target="_blank">
                                    <img :src="getAssetImage('instagram.svg')">
                                    <span>Instagram</span>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a href="https://t.me/changirecommends" target="_blank">
                                    <img :src="getAssetImage('icons8-telegram-48.png')">
                                    <span>Telegram</span>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a href="https://www.linkedin.com/company/changitravelservices" target="_blank">
                                    <img :src="getAssetImage('linkedin-in.svg')">
                                    <span>LinkedIn</span>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a href="https://www.youtube.com/@ChangiRecommendsSG" target="_blank">
                                    <img :src="getAssetImage('icons8-youtube-24.png')">
                                    <span>Youtube</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navbar-footer pt-4 pb-3">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <p class="mb-1">@Copyright 2025 Changi Travel Services Pte Ltd. All Rights Reserved.<br/> Travel Agent Licence
                                No: 02258 
                            </p>
                        </div>
                        <div class="col-lg-6 link-container">
                            <ul class="nav-footer list-inline text-end text-xl-end mb-0">
                                <li class="list-inline-item"><a class="footer-link" href="https://www.changirecommends.com/page.aspx?p=aboutus">About Us</a></li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item"><a class="footer-link"  href="https://www.changirecommends.com/contactus.aspx">Contact Information</a></li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item"><a class="footer-link"  href="mailto:call@changirecommends.com.sg">Email Enquiry</a></li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item"><a class="footer-link"  href="https://www.changirecommends.com/findus.aspx">Find Us</a></li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item"><a class="footer-link"  href="https://www.changirecommends.com/page.aspx?p=faq">Changi Recommends FAQ</a></li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item"><a class="footer-link"  href="https://www.changirecommends.com/page.aspx?p=changi_rewards_faq">Changi Rewards FAQ</a></li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item"><a class="footer-link"  href="https://www.changirecommends.com/page.aspx?p=policy " target="_blank">Terms of Use</a></li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item"><a class="footer-link"  href="https://www.changitravelservices.com/privacy-policy " target="_blank">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
  <!-- <div class="footer-container" v-if="!$root.simple_layout"> -->
    <!-- Back to top 
    <div class="button-top" @click="scrollToTop">
      <img class="button-top__icon" :src="getAssetImage('chevron-up.png')" />
      BACK TO TOP
    </div>-->

    <!-- Top menu (links row above the main footer) 
    <b-container class="footer-top-menu">
      <b-row class="p-4 footer-top-menu--inside">
        <b-col
          cols="xl-8"
          class="text-xl-right text-center float-xl-right mb-xl-0 mb-2 footer-menu"
        >
          <ul class="nav justify-content-xl-end justify-content-center">
            <li
              v-for="(footerMenu, idx) in footerTopMenuItems"
              :key="`top-${idx}`"
              v-if="footerMenu && footerMenu.enabled"
              class="nav-item"
            >
              <b-link
                :href="footerMenu.value"
                :ref="footerMenu.name"
                :target="footerMenu.target"
                class="text-muted ml-xl-2 mx-1"
                v-html="footerMenu.name"
              />
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>-->

    <!-- Main footer -->
    <!-- <b-container class="footer-top" data-cy="core-footer">
      <b-row class="p-3 pt-4">-->
        <!-- Newsletter -->
       <!-- <b-col cols="lg-6" class="pt-lg-3 left-content">
          <div class="img-holder-paper-plane">
              <img :src="getAssetImage('paper-plane.svg')">
          </div>
          <div class="subscribe-desc-holder">
              <b class="text-dark fs-5">Sign up for Newsletter</b><br />
              Enter your email to receive latest updates
          </div>

          <MailchimpSignupForm
            :mailchimpUserId="mailchimpUserId"
            :mailchimpAudienceId="mailchimpAudienceId"
            :defaultMailchimpUserId="defaultMailchimpUserId"
            :defaultMailchimpAudienceId="defaultMailchimpAudienceId"
          />
        </b-col> -->

        <!-- Contact + Social -->
        <!-- <div class="mobile-wrapper-container">
          <b-col cols="lg-3" class="contact-us-wrapper pt-lg-3 pt-2">
            <CrContactUsMenu />
          </b-col>
          <b-col cols="lg-3" class="social-links-container h4 pt-lg-3 pt-2">
            <div class="social-links-inner-con pl-lg-5 text-lg-left text-left">
              <h3>Follow us</h3>
              <ul class="social-links">
                <li
                  v-for="(socialLink, idx) in footerSocialLinks"
                  :key="`soc-${idx}`"
                  class="nav-item"
                >
                  <b-link
                    :href="socialLink.link"
                    :ref="socialLink.name"
                    target="_blank"
                    class="text-dark"
                    v-html="socialLink.icon"
                  />
                </li>
              </ul>
            </div>
          </b-col>
        </div>
      </b-row>
    </b-container> -->

    <!-- Bottom menu + copyright -->
    <!-- <b-container class="footer-bottom">
      <b-row class="p-4 position-relative">
        <b-col
          cols="xl-4"
          class="text-xl-right text-center float-xl-right mb-xl-0 mb-2 footer-menu"
        >
          <ul class="nav justify-content-xl-end justify-content-center">
            <li
              v-for="(footerMenu, idx) in footerMenuItems"
              :key="`btm-${idx}`"
              v-if="footerMenu && footerMenu.enabled"
              class="nav-item"
            >
              <b-link
                :href="footerMenu.value"
                :ref="footerMenu.name"
                :target="footerMenu.target"
                class="text-muted ml-xl-2 mx-1"
                v-html="footerMenu.name"
              />
            </li>
          </ul>
        </b-col>

        <b-col
          cols="xl-8"
          class="text-muted text-xl-left text-center footer-copywrite"
        >
          © Copyright {{ new Date().getFullYear() }}
          Changi Travel Services Pte Ltd. All Rights Reserved.
          Travel Agent Licence No: 02258
        </b-col>
      </b-row>
    </b-container>
  </div> -->
</template>

<script>
// Subcomponents
import MailchimpSignupForm from './MailchimpSignupForm.vue'
import CrContactUsMenu from './CrContactUsMenu.vue'
import axios from 'axios'
import { mapState, mapGetters, mapActions } from 'vuex'

// Read env the Vue-CLI way (Vue 2):
const CORE_URL = process.env.VUE_APP_CORE_URL || ''               // e.g. https://core.example.com
const API_DOMAIN = process.env.VUE_APP_API_DOMAIN || ''           // e.g. https://changiassure.changitravel.tech
const DEFAULT_MENU_SLUG = 'cr-footer-menu'

export default {
  name: 'CrFooter',
  components: { MailchimpSignupForm, CrContactUsMenu },

  computed: {
    ...mapState('authModule', ['isLoggedIn']),
    ...mapState('settingsModule', ['settings']),
    ...mapGetters('settingsModule', ['getSettingByKey','getSettingByKeys']),
  },

  props: {
    /**
     * Bottom footer menu slug (defaults to env)
     */
    footerMenuSlug: {
      type: String,
      default: () => DEFAULT_MENU_SLUG
    },
    /**
     * Top-of-footer menu slug (nullable; pass from App if needed)
     */
    footerTopMenuSlug: {
      type: String,
      default: null
    },
    mailchimpUserId: { type: String, default: null },
    mailchimpAudienceId: { type: String, default: null }
  },

  data () {
    return {
      defaultMailchimpUserId: '',
      defaultMailchimpAudienceId: '',
     
      _cancels: []
    }
  },

  async created () {
    // Menus
    if (CORE_URL && this.footerMenuSlug) {
      this.fetchMenu(this.footerMenuSlug).then(items => { this.footerMenuItems = items })
    }
    if (CORE_URL && this.footerTopMenuSlug) {
      this.fetchMenu(this.footerTopMenuSlug).then(items => { this.footerTopMenuItems = items })
    }

    // Defaults for Mailchimp IDs
    if (API_DOMAIN) {
      await this.fetchSettings();
      this.defaultMailchimpAudienceId = this.settings.newsletter_list_key?.attractions_subscribers || '';
      this.defaultMailchimpUserId = this.settings.default_mailchimp_user_id || '';
    }
  },

  beforeDestroy () {
    // cancel any pending axios requests to avoid state updates on destroyed component
    if (this._cancels && Array.isArray(this._cancels)) {
      this._cancels.forEach(c => { try { c() } catch (e) {} })
      this._cancels = []
    }
  },

  methods: {
    ...mapActions('settingsModule', ['loadSettings']),

    getAssetImage (name) {
      // keep webpack-friendly require for static images
      return require(`../assets/images/${name}`)
    },

    scrollToTop () {
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },

    async fetchMenu (slug) {
      try {
        const source = axios.CancelToken.source()
        if (!this._cancels) {
          this._cancels = []
        }
        this._cancels.push(source.cancel)

        const { data } = await axios.get(`${CORE_URL}/api/get-menu/${encodeURIComponent(slug)}`, {
          cancelToken: source.token,
          withCredentials: false
        })
        // Expecting array of { name, value, target, enabled }
        return Array.isArray(data) ? data : []
      } catch (e) {
        // fail silent, keep empty menu
        return []
      }
    },

    async fetchSettings () {
      try {
        await this.loadSettings();
        return data || {}
      } catch (e) {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>

footer .row {
	margin: auto;

}

@media (max-width: 992px) {
	footer .navbar-footer .row {
		flex-direction: column-reverse;
	}

	footer .navbar-footer .row>div.link-container {
		margin-bottom: 1rem;
	}

	.text-end {
		text-align: left !important
	}
}

.navbar-social {
	background-color: #f1f4ff;
 
  .social-media{
    text-align:right;
    margin-top:-1px;
    @media (max-width:1200px){
      text-align:left;
      margin-top:10px;
      }
    }
  
}

.navbar-social .left-content {
	position: relative;
	height: 54px;
}

.navbar-social .list-inline-item {
	margin-right: 1.7rem;
  
}

.navbar-social .social-media img {
	height: 15px;
	margin-right: 0.3em;
	margin-top: -3px;
  display:inline;


}

.navbar-social .social-media a {

	color: #6c757d;
	text-decoration: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display:inline-block;
  &:hover{
    text-decoration:none!important;
    transform: translateY(-2px)!important;
  }
}


.img-holder-paper-plane {
	width: 35px;
	opacity: 0.65;
	position: absolute;
	left: 0px;
	top: 3px;
}

.subscribe-desc-holder {
	display: inline-block;
	font-size: 0.8rem;
	position: absolute;
	left: 45px;
	top: -5px;
  text-align:left;
}

.subscribe-desc-holder b {
	font-size: 1.1rem;
}
.navbar-footer {
  background: linear-gradient(90deg, #335dff 0%, #5e4cff 100%);
  font-size: 0.8rem;
  color:#ddd;
  p{
    color: #fff!important;
  }
  .nav-footer {
    font-size: 0.8rem;
    text-align:right;
   
    li.list-inline-item{
      color:#fff;
      a.footer-link {
        text-decoration: none;
        color: #fff!important;
        &:hover{
          text-decoration: underline;
          color: #fff!important;
        }
        
      }
    }
  }
}
</style>